import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { BUDGET_TABS, BudgetsPage, type BudgetTab } from "@/features/budgets/BudgetsPage";

const search = z.object({ peek: z.string().optional(), by: z.enum(["client", "portfolio", "service"]).optional() });

export const Route = createFileRoute("/_app/budgets/$tab")({
  validateSearch: search,
  component: Page,
});

function Page() {
  const { tab } = Route.useParams();
  return <BudgetsPage tab={(BUDGET_TABS as readonly string[]).includes(tab) ? (tab as BudgetTab) : "projects"} search={Route.useSearch()} />;
}
